import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { PageHeader } from "@/components/PageHeader";
import { PlexCard } from "@/components/sources/PlexCard";
import { useAuth } from "@/context/AuthContext";

export default function Sources() {
  const [params, setParams] = useSearchParams();
  const [tick] = useState(0);
  const { user } = useAuth();
  useEffect(() => {
    if (params.toString()) setParams({}, { replace: true });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      <PageHeader eyebrow="Manage" title="Sources" testid="sources-title" sub="Stream straight from your Plex server — nothing is copied." />
      {user?.shared_from ? (
        <div className="max-w-3xl rounded-xl border border-amber-200 bg-amber-50 p-6 text-sm text-amber-900 animate-rise" data-testid="shared-library-notice">
          You're watching <b>{user.shared_from_name || "a shared"}</b>'s library, so there's nothing to set up here. Ask an administrator if you want your own sources.
        </div>
      ) : (
        <div className="grid max-w-5xl gap-8" key={tick}>
          <PlexCard />
        </div>
      )}
    </div>
  );
}
